import { BaSeTheme } from '@base/react';
import styled, { css } from 'styled-components';

export const BodyCard = styled.div`
  background: ${BaSeTheme.colors.defaultColors.white};
  box-shadow: ${BaSeTheme.shadows.profundidade2};
  border-radius: 8px;
`;

export const BodyCardCell = styled.div`
  ${({ hideBorder, small, isBlue, start, end }) => css`
    padding: ${small ? '8px' : '14px'} 24px;
    background-color: ${isBlue
      ? BaSeTheme.colors.institucionais.azulSebrae97
      : BaSeTheme.colors.defaultColors.white};
    ${!hideBorder &&
    `border-bottom: 1px solid ${BaSeTheme.colors.institucionais.cinzaSebrae90};`}
    ${start &&
    `
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
    `}
    ${end &&
    `
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
    `}
  `}
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  ${({ full }) => css`
    ${full && 'width: 100%;'}
  `}
`;

export const WrapperGrid = styled.div`
  display: grid;
  gap: 16px;
`;
